import {
    SET_ACCOUNT_STATS,
    UPDATE_ACCOUNT_STATS,
    STOP_UPDATING_ACCOUNT_STATS
} from '../actions/steemAccountActions';

import hive from '@hiveio/hive-js';

const initialState = {
    loading: true,
    post_count: 0,
    voting_manabar: 0,
    downvote_manabar: 0,
    resource_credits: 0,
    reputation: 25,
    hive: 0,
    hive_power: 0,
    hbd: 0,
    website: '',
    about: '',
    reward_hbd: null,
    reward_hive: null,
    reward_hive_power: null,
    walletHistory: []

};

export default function (state = initialState, action) {
    switch (action.type) {
        case SET_ACCOUNT_STATS: return setAccountStats(state, action);
        case UPDATE_ACCOUNT_STATS: return {...state, loading: true};
        case STOP_UPDATING_ACCOUNT_STATS: return {...state, loading: false};
        default:
            return state;
    }
}

const parseAsset = (asset) => {
    return parseFloat(asset.replace(" HIVE", "").replace(" HBD", "").replace(" STEEM", "").replace(" SBD", "")).toFixed(3);
}

const setAccountStats = (state, action) => {

    const stats = {
        post_count: action.account.post_count,
        voting_manabar: calcaulateVotingManabar(action.account),
        downvote_manabar: calcaulateDownvoteManabar(action.account),
        resource_credits: action.rc.toFixed(2),
        reputation: calculateReputation(action.account),
        hive_power: calculateHivePower(action.account, action.properties),
        hive: parseAsset(action.account.balance),
        hbd: action.account.hbd_balance ? parseAsset(action.account.hbd_balance) : parseAsset(action.account.sbd_balance),
        website: setWebsite(action.account),
        about: setAbout(action.account),
        reward_hbd: action.account.reward_hbd_balance ? parseAsset(action.account.reward_hbd_balance) : parseAsset(action.account.reward_sbd_balance),
        reward_hive_power: action.account.reward_vesting_hive ? parseAsset(action.account.reward_vesting_hive) : parseAsset(action.account.reward_vesting_steem),
        reward_hive: action.account.reward_hive_balance ? parseAsset(action.account.reward_hive_balance) : parseAsset(action.account.reward_steem_balance),
        walletHistory: action.walletHistory,
        loading: false
    }

    return {
        ...state,
        ...stats
    };
}

const calcaulateVotingManabar = (account) => {

    const CURRENT_UNIX_TIMESTAMP = parseInt((new Date().getTime() / 1000).toFixed(0))
    //calculate available SP

    const totalShares = parseFloat(account.vesting_shares) + parseFloat(account.received_vesting_shares) - parseFloat(account.delegated_vesting_shares) - parseFloat(account.vesting_withdraw_rate);

    //determine elapsed time since last RC update
    const elapsed = CURRENT_UNIX_TIMESTAMP - account.voting_manabar.last_update_time;

    const maxMana = totalShares * 1000000;

    //calculate current mana for the 5 day period (432000 sec = 5 days)
    let currentMana = parseFloat(account.voting_manabar.current_mana) + elapsed * maxMana / 432000;

    if (currentMana > maxMana) {
        currentMana = maxMana;
    }

    //determine percentage of available mana(RC)
    const currentManaPerc = currentMana * 100 / maxMana;

    return currentManaPerc.toFixed(2);
}

const calcaulateDownvoteManabar = (account) => {

    const CURRENT_UNIX_TIMESTAMP = parseInt((new Date().getTime() / 1000).toFixed(0))
    //calculate available SP

    const totalShares = parseFloat(account.vesting_shares) + parseFloat(account.received_vesting_shares) - parseFloat(account.delegated_vesting_shares) - parseFloat(account.vesting_withdraw_rate);

    //determine elapsed time since last RC update
    const elapsed = CURRENT_UNIX_TIMESTAMP - account.downvote_manabar.last_update_time;

    const maxMana = totalShares * 1000000 / 4;

    //calculate current mana for the 5 day period (432000 sec = 5 days)
    let currentMana = parseFloat(account.downvote_manabar.current_mana) + elapsed * maxMana / 432000;

    if (currentMana > maxMana) {
        currentMana = maxMana;
    }

    //determine percentage of available mana(RC)
    const currentManaPerc = currentMana * 100 / maxMana;

    return currentManaPerc.toFixed(2);
}

const calculateHivePower = (account, properties) => {

    const totalShares = parseFloat(account.vesting_shares) + parseFloat(account.received_vesting_shares) - parseFloat(account.delegated_vesting_shares) - parseFloat(account.vesting_withdraw_rate);
    const power = hive.formatter.vestToHive(totalShares, properties.total_vesting_shares, properties.total_vesting_fund_hive);
    return power.toFixed(3);
}

const calculateReputation = (account) => {

    const _reputation = parseInt(account.reputation);

    let rep = String(_reputation);
    const neg = rep.charAt(0) === "-";
    rep = neg ? rep.substring(1) : rep;
    const str = rep;
    const leadingDigits = parseInt(str.substring(0, 4));
    const log = Math.log(leadingDigits) / Math.log(10);
    const n = str.length - 1;
    let out = n + (log - parseInt(log));
    if (isNaN(out)) out = 0;
    out = Math.max(out - 9, 0);
    out = (neg ? -1 : 1) * out;
    out = out * 9 + 25;
    out = parseFloat(out).toFixed(3);
    return out;
}

const setWebsite = (account) => {
    const metadata = JSON.parse(account.posting_json_metadata);
    if(!metadata || !metadata.profile) {
        return ''; // null?
    }

    const {profile: { website }} = metadata;
    return website;

}

const setAbout = (account) => {
    const metadata = JSON.parse(account.posting_json_metadata);
    if(!metadata || !metadata.profile) {
        return "";
    }
    const {profile: { about }} = metadata;
    return about;
}
